import { makeActionCreator } from '../../../../utilities'
import { SessionResumeConstants } from './sessionResume.constants'

export const setSessionResumeShowModal = makeActionCreator(
  SessionResumeConstants.SET_SESSION_RESUME_SHOW_MODAL,
  'showSessionResumeModal'
)
export const resetSession = makeActionCreator(SessionResumeConstants.RESET_SESSION)
export const setUser = makeActionCreator(SessionResumeConstants.SET_USER, 'user')
